import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=d501edf8&scoped=true&"
import script from "./marketplace.vue?vue&type=script&lang=js&"
export * from "./marketplace.vue?vue&type=script&lang=js&"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=d501edf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d501edf8",
  null
  
)

export default component.exports